/* site/cms/api.js — the builder's HTTP surface (2026-09-12). ONE place that knows the endpoints;
 * the backend twin is backend/site_cms.py (router mounted under /api). Public reads carry no
 * token; admin writes send the platform bearer token exactly like the rest of the admin. */
import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;
const token = () => { try { return localStorage.getItem("lhc_token"); } catch (e) { return null; } };
const auth = () => ({ headers: { Authorization: `Bearer ${token()}` } });
const data = (r) => (r && r.data) || null;

/* ── public (no auth) ────────────────────────────────────────────────────── */
/** published page by slug (slugs may contain "/", hence a query param) →
 *  {id,title,slug,seo,published:{sections,publishedAt}} | 404 */
export const fetchPublishedPage = (slug) => axios.get(`${API}/site/page`, { params: { slug }, headers: { Authorization: undefined } }).then(data);
/** [{id,title,slug}] of published pages (nav pickers, sitemap, search) */
export const fetchPublishedIndex = () => axios.get(`${API}/site/pages/published`, { headers: { Authorization: undefined } }).then(data);
/** public site settings: {nav:{items:[...]}, logo, header, footer} — merged by SiteChrome over its defaults */
export const fetchSiteSettings = () => axios.get(`${API}/site/settings`).then(data);

/* ── admin (superadmin) ──────────────────────────────────────────────────── */
export const listPages = () => axios.get(`${API}/admin/site/pages`, auth()).then(data);
export const getPage = (id) => axios.get(`${API}/admin/site/pages/${id}`, auth()).then(data);
export const createPage = (page) => axios.post(`${API}/admin/site/pages`, page, auth()).then(data);
/** saves title/slug/seo/template/order and the DRAFT tree; never touches `published` */
export const savePage = (id, page) => axios.put(`${API}/admin/site/pages/${id}`, page, auth()).then(data);
export const deletePage = (id) => axios.delete(`${API}/admin/site/pages/${id}`, auth()).then(data);
export const duplicatePage = (id) => axios.post(`${API}/admin/site/pages/${id}/duplicate`, {}, auth()).then(data);
/** copies draft → published, status "published" */
export const publishPage = (id) => axios.post(`${API}/admin/site/pages/${id}/publish`, {}, auth()).then(data);
export const unpublishPage = (id) => axios.post(`${API}/admin/site/pages/${id}/unpublish`, {}, auth()).then(data);

export const listTemplates = () => axios.get(`${API}/admin/site/templates`, auth()).then(data);
export const createTemplate = (tpl) => axios.post(`${API}/admin/site/templates`, tpl, auth()).then(data);
export const deleteTemplate = (id) => axios.delete(`${API}/admin/site/templates/${id}`, auth()).then(data);

export const getSettings = () => axios.get(`${API}/admin/site/settings`, auth()).then(data);
export const saveSettings = (settings) => axios.put(`${API}/admin/site/settings`, settings, auth()).then(data);

/** [{url,name,size,type,createdAt}] from the platform upload folder */
export const listMedia = () => axios.get(`${API}/admin/site/media`, auth()).then(data);
/** the EXISTING upload endpoint (multipart "file") → {url} */
export const uploadMedia = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return axios.post(`${API}/admin/site/media`, fd, { headers: { ...auth().headers, "Content-Type": "multipart/form-data" } }).then(data);
};
export const deleteMedia = (name) => axios.delete(`${API}/admin/site/media/${encodeURIComponent(name)}`, auth()).then(data);

/** the server's error message, for toasts */
export const errorText = (e, fallback = "Something went wrong") =>
  (e && e.response && e.response.data && (e.response.data.detail || e.response.data.message)) || (e && e.message) || fallback;
